import { ModalContext } from 'app/app';
import axios from 'axios';
import { ViewContext } from 'components/lib';
import { Fragment, useContext, useState, useEffect } from 'react';
import { Download, FileText, X } from "feather-icons-react/build/IconComponents";
import styles from './styles.module.scss';

export function QuoteDocumentsModal() {
  const context = useContext(ViewContext);
  const { modal, setModal } = useContext(ModalContext);
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchDocuments = async () => {
    if (!modal.data?.companyId) return;
    
    
    setLoading(true);
    try {
      // Try searching by company_id first
      let url = `/api/document?page=1&search=&company_id=${modal.data.quoteId}&status=active`;
      let response = await axios.get(url);
      const documents = response.data.data?.documents || response.data.data?.data || response.data?.data || [];
      setDocuments(documents);
    } catch (error) {
      console.error('Error fetching documents:', error);
      context.notification.show(
        'Failed to load documents',
        'error',
        true,
        'toast',
        'x-circle'
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (document) => {
    try {
      if (document.s3_link) {
        // Direct download from S3 link
        window.open(document.s3_link, '_blank');
      } else {
        // Download via API endpoint
        const response = await axios.get(`/api/document/${document.id}/download`, {
          responseType: 'blob',
        });
        
        // Create blob URL and trigger download
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = document.name || 'document';
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      }
    } catch (error) {
      console.error('Error downloading document:', error);
      context.notification.show(
        'Failed to download document',
        'error',
        true,
        'toast',
        'x-circle'
      );
    }
  };

  const getDocumentIcon = (type) => {
    const iconProps = { size: 16, color: "#637381" };
    return <FileText {...iconProps} />;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return new Date(dateString).toLocaleDateString();
    } catch {
      return 'N/A';
    }
  };

  const formatType = (type) => {
    if (!type) return 'Document';
    return type.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  };

  useEffect(() => {
    if (modal.name === 'quote_documents_modal') {
      fetchDocuments();
    }
  }, [modal.name, modal.data?.companyId]);

  return (
    <Fragment>
      {modal.name === 'quote_documents_modal' && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.header}>
              <div className={styles.title}>
                Documents for Quote #{modal.data?.submissionNumber}
              </div>
              <button
                className={styles.closeButton}
                onClick={() => setModal('')}
                title="Close"
              >
                <X size={20} />
              </button>
            </div>
            
            <div className={styles.content}>
              {modal.data?.companyName && (
                <div className={styles.subTitle}>
                  Company: {modal.data.companyName}
                </div>
              )}
              
              {loading ? (
                <div className={styles.loading}>
                  <div className={styles.spinner}></div>
                  <p>Loading documents...</p>
                </div>
              ) : documents.length === 0 ? (
                <div className={styles.emptyState}>
                  <FileText size={48} color="#ccc" />
                  <h3>No Documents Found</h3>
                  <p>No documents have been uploaded for this quote yet.</p>
                </div>
              ) : (
                <div className={styles.documentsTable}>
                  <table>
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th>Name</th>
                        <th>Uploaded</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {documents.map((doc) => (
                        <tr key={doc.id}>
                          <td>
                            <div className={styles.typeCell}>
                              {getDocumentIcon(doc.type)}
                              <span>{formatType(doc.type)}</span>
                            </div>
                          </td>
                          <td>
                            <div className={styles.nameCell}>
                              {doc.name}
                            </div>
                          </td>
                          <td>
                            <div className={styles.dateCell}>
                              {formatDate(doc.createdAt)}
                            </div>
                          </td>
                          <td>
                            <div className={styles.actionsCell}>
                              {doc.s3_link ? (
                                <button
                                  onClick={() => handleDownload(doc)}
                                  className={styles.downloadButton}
                                  title="Download document"
                                >
                                  <Download size={16} />
                                </button>
                              ) : (
                                <span className={styles.noFile}>No file</span>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            
            <div className={styles.footer}>
              <button
                className={styles.closeButton}
                onClick={() => setModal('')}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
} 